export default __webpack_public_path__ + "static/media/passport.1e402d8c.svg";